import isEmpty from 'lodash/isEmpty';

const addFreight = (sum, freight) =>
  sum + freight.getIn(['options', 0, 'price']) + freight.getIn(['options', 0, 'valorImpostos'], 0);

export const cartSummary = (cart, cartFreight, isCheckout = false) => {
  const temporary = !isCheckout && (!isEmpty(cartFreight) || cart.getIn(['products', 'freight']) > 0);

  const taxes = temporary
    ? Object.values(cartFreight).reduce((sum, freight) => sum + freight.getIn(['options', 0, 'valorImpostos'], 0), 0)
    : cart.getIn(['installment', 'totalImpostos']);

  let freight;

  if (isCheckout) {
    freight = cart.getIn(['products', 'freight']);
  } else if (!isEmpty(cartFreight)) {
    freight = Object.values(cartFreight).reduce(
      (sum, freightReduce) => sum + freightReduce.getIn(['options', 0, 'price']),
      0
    );
  }

  const total = temporary
    ? Object.values(cartFreight).reduce(addFreight, cart.getIn(['products', 'subtotal']))
    : cart.getIn(['installment', 'totalAVista']);

  return { taxes, freight, total, temporary };
};

export default cartSummary;
